var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"商品详情","visible":_vm.visible,"before-close":_vm.handleClose,"width":"1250px","top":"5vh"},on:{"update:visible":function($event){_vm.visible=$event},"open":_vm.handleOpen}},[_c('SalesGoodsDetail',{ref:"salesGoodsDetailRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }